import { createBrowserHistory } from "history";

export default class HistoryService {
  public static service = createBrowserHistory({
    basename: "/",
  });
}
